module.exports = __webpack_public_path__ + "static/fipcgreystarmain-a7b9185fab239a7da36878aa1cb8b1cc.jpeg";